import { ChangeEvent } from 'react'
import { IRetailForm } from 'shared/interfaces/retail'

export enum EOpeningHourType {
	BUSINESS_DAY = 'bussinessDay',
	HOLYDAY = 'holyDay',
}

export interface IViewProps {
	tableColumns: any[]
	tableRows: Object[]
	loading: boolean
	showModal: boolean
	externalIDloading: boolean
	editOfferModal: boolean
	onCloseModalOffer(): void
	editOffers(): void
	onCloseModal(): void
	changeModalState(): void
	handleChange(props: {
		event: ChangeEvent<HTMLInputElement>
		isAddress?: boolean
	}): void
	handleSelectChange(
		type: EOpeningHourType,
		position: 'start' | 'end',
		valueHour: string,
	): void
	handleOfferChange(switchState: boolean): void
	selectedRetail: IRetailForm
	create(): void
	edit(): void
	deleteModal: boolean
	changeDeleteModalState(): void
	deleteRetails(): void
	isFormValid: boolean
	returnSelectedOptions(
		hour: string,
	): { value: string; label: string } | undefined
	setMissingExternalApiReferenceToast(): void
}
